import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import $ from 'jquery';
import {IMAGE_ROOT} from "../api-config";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';
class password_reset_success extends Component {

    constructor(props) {
        super(props);

        this.state = {
            windowHeight: 0,
            test:"",
        };
       // this.updateState = this.updateState.bind(this);
    };

    updateState(e) {
        this.setState({});
    }

    componentWillMount() {


        var height = $(window).height();

        this.setState({windowHeight: height});


        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
    }

    componentDidMount() {

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }

        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }



        $('#home').css('background', 'none');
    }

    render() {

        const {t} = this.props;

        return (
            <div>
                <div className="left_panel_block" style={{height: '100vh'}}>
                    <div className="left_panel">
                        <div className="left_panel_content">
                            <img src={IMAGE_ROOT + "/images/product/" + localStorage.getItem('store_image')}
                                 alt="Takecharge Dinner Logo"/>
                            <h3 className="text-center">{t('reset_password')}</h3>
                        </div>
                    </div>
                </div>
                <div className="right_panel h-auto h-100" style={{height: '100vh'}}>
                    <header>
                        <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                            <Link to="/forgotpassword"></Link>
                            <h2 className="text-center"><strong>{t('reset_password')} </strong></h2>
                        </div>
                    </header>
                    <div className="simple-box scrollClass">
                        <div className="header-title">
                            <h2 className="text-center" style={{paddingTop: '50px'}}>{t('reset_success')}</h2>
                        </div>
                        <div className="header-content help_content">
                            <p className="font-family-bold">{t('login_inst')}</p>
                        </div>
                        <Link to="/" className="link_button">{t('login')}</Link>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}

export default withRouter(withTranslation()(password_reset_success));



// WEBPACK FOOTER //
// ./src/view_components/password_reset_success.js